import type {
  ApprovalDialogFormData,
  ApprovalDialogStatusOption,
  RevokeFormData,
} from "./types";

export const APPROVE_FORM_DEFAULT_VALUES: ApprovalDialogFormData = {
  status: "Approved",
  reason: "",
} as const;

export const REVOKE_FORM_DEFAULT_VALUES: RevokeFormData = {
  reason: "",
};

export const APPROVE_STATUS_OPTIONS: ApprovalDialogStatusOption[] = [
  { value: "Approved", label: "Approve", id: "status-approved" },
  {
    value: "ApprovalRejected",
    label: "Reject",
    id: "status-rejected",
  },
];

export const REJECT_REASONS = [
  "Failing policy checks fall outside of organizational risk appetite",
  "Alternate software selected for approval that poses less security risk",
];

export const APPROVE_REASONS = [
  "No failing policy checks identified during analysis",
  "Failing policy checks manually risk-accepted and/or suppressed",
];

export const REVOKE_REASONS = [
  "Fixing inadvertent or incorrect approval of software",
  "Retroactive modification to policy configuration or organisational risk appetite",
  "Alternate software with lesser security risk selected for replacement",
  "New risk/threat identified which impacts components of approved software",
];
